import React from 'react';
import { Table } from 'semantic-ui-react';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import RowAddColumn from '@/components/table/RowAddColumn';
import formObjectSummaryFields from '../helper';

const buildColumns = (parent) => formObjectSummaryFields(parent).map((field) => (
  <UnsortedColumn
    key={`form_object_table_column_${parent.name}_${field.name}`}
    columnText={field.label}
  />
));

const FormObjectsTableColumns = ({
  addItem,
  allowAdd,
  canEdit,
  field,
}) => (
  <Table.Row className="aridhia-form-objects-table-columns">
    {buildColumns(field)}
    {canEdit && (
    <RowAddColumn
      colWidth={1}
      disabled={!allowAdd}
      entity="catalogue.object"
      onClick={addItem}
      text={field.placeholder}
    />
    )}
  </Table.Row>
);

export default FormObjectsTableColumns;
